import { useSearchParams } from 'react-router'
import { useIntl } from 'react-intl'

import './FilterSelector.css'

export default function FilterSelector() {
  const intl = useIntl()
  const [searchParams, setSearchParams] = useSearchParams()
  const isPublic = searchParams.get('isPublic')

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      if (e.target.value === '') {
        next.delete('isPublic')
      } else {
        next.set('isPublic', e.target.value)
      }
      return next
    })
  }

  return (
    <div className="filter-selector">
      <span className="icon icon-filter" />
      <select
        name="filter"
        value={isPublic ?? ''}
        onChange={handleChange}
        aria-label={intl.formatMessage({ id: 'filter.label' })}
      >
        <option value="">{intl.formatMessage({ id: 'filter.all' })}</option>
        <option value="true">
          {intl.formatMessage({ id: 'privacy.public' })}
        </option>
        <option value="false">
          {intl.formatMessage({ id: 'privacy.private' })}
        </option>
      </select>
      <span className="icon icon-angle-down" />
    </div>
  )
}
